import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { setTabs } from 'modules/common/Tabs/actions';
import ReportsContainer from 'modules/security/containers/ReportsContainer';
import Header from 'modules/common/Header';
import { tabs } from './constants';
import TripsTabContainer from '../TripsTabContainer';
import Resources from '../Resources';
import TripContainer from '../TripContainer';
import Booking from '../Booking';
import DirectorSettings from '../DirectorSettings';
import SMCcars from '../SMCcars';
import BlackList from '../BlackList';

export const Director: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTabs(tabs));
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Switch>
        <Route path="/director" exact render={(props) => <TripsTabContainer {...props} lolomode={1} />} />
        <Route path="/director/unload" exact render={(props) => <TripsTabContainer {...props} lolomode={2} />} />
        <Route path="/director/reports" component={ReportsContainer} />
        <Route path="/director/trip/:tripId" component={TripContainer} />

        <Route path="/director/booking" component={Booking} />
        <Route path="/director/resources" component={Resources} />
        <Route path="/director/smc" component={SMCcars} />
        <Route path="/director/blackList" component={BlackList} />
        <Route path="/security/reports" component={ReportsContainer} />
        <Route path="/director/setting" component={DirectorSettings} />
      </Switch>
    </React.Fragment>
  );
};
